import { CONTACTS } from 'src/data/contacts.ts';
import { RESULT_TYPES } from 'src/data/result-types.ts';
import { getResultType } from 'src/lib/scoring.ts';
import { Answers, Contact, Demographics, ResultType } from 'src/types/types.ts';

import type { Level } from '../components/ui/level-scores.tsx';

export type ResultPdfData = {
  overall: number;
  resultType: ResultType;
  resultTypes: ResultType[];
  contacts: Contact[];
  lead: { name: string; company: string; email: string };
  context?: Demographics;
  dateLabel: string;
  dateIso: string;
  answers: Answers;
  levels: Level[];
};

export function buildResultPdfData(opts: {
  overall: number;
  lead: { name: string; company: string; email: string };
  answers: Answers;
  levels: Level[];
  context?: Demographics;
  now?: Date;
}): ResultPdfData {
  const now = opts.now ?? new Date();
  return {
    overall: opts.overall,
    resultType: getResultType(opts.overall || 1),
    resultTypes: RESULT_TYPES,
    contacts: CONTACTS,
    lead: opts.lead,
    context: opts.context,
    dateLabel: formatDateDe(now),
    dateIso: toIsoDate(now),
    answers: opts.answers,
    levels: opts.levels
  };
}

function formatDateDe(d: Date) {
  return new Intl.DateTimeFormat('de-DE', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }).format(d);
}

function toIsoDate(d: Date) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
